import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import type {IconSize} from '@Components/icon-v2/icon.types';
import {IconType} from '@Components/icon-v2/icon.types';
import {IconShape} from '@Components/icon-v2/icon.types';
import styles from './icon-group.module.scss';
import {noop} from '@Utils/general.util';

export interface IconGroupProps {
  icons: IconInfo[];
  size?: IconSize;
  onIconSelect: (id: string) => void;
}

export interface IconInfo {
  id: string;
  name: string;
  isSelected: boolean;
}

export function IconGroup({icons = [], onIconSelect = noop, ...props}: IconGroupProps): ReactElement {
  return (
    <div className={`flex-row-align-center radius-4 ${styles.container}`}>
      {icons.map((icon, index) => {
        return (
          <div key={icon.id} className={'flex-row-align-center'}>
            <Icon
              icon={icon.name}
              {...props}
              type={IconType.GHOST}
              shape={IconShape.SQUARE}
              isSelected={icon.isSelected}
              onClick={(): void => {
                onIconSelect(icon.id);
              }}
            />
            {index + 1 !== icons.length ? <div className={styles.divider} /> : null}
          </div>
        );
      })}
    </div>
  );
}
